<template>
  <div class="d-flex align-center" @click.stop>
    <div class="mr-2 text-center">
      <InputFormatadorDeValor
        v-model="linha.sugestao_compra_peso"
        :removerValorIrrelevante="true"
        centralizar
        :sufixo="linha.idunidade_medida"
        class="input-regular font-12"
        :disabled="DISABILITAR_EDICAO_INPUT"
        @focus="$event.target.select()"
        @keyup.enter="adicionarCategoriaNoCarrinho"
        @keydown.prevent.up="incrementarSugestao"
        @keydown.prevent.down="decrementarSugestao"
      />
    </div>

    <v-spacer />

    <template>
      <ValidaLoteMinimo
        v-if="!LOTE_MINIMO_VALIDO"
        v-model="linha.sugestao_compra_peso"
        :lote-minimo="linha.lote_minimo"
        @change="adicionarCategoriaNoCarrinho"
        @forcar-sugestao="linha.comprar_fora_lote_minimo = true;adicionarCategoriaNoCarrinho();"
      />

      <v-btn
        v-else
        :disabled="DISABILITAR_EDICAO_INPUT || linha.sugestao_compra_peso <= 0"
        icon
        @click="adicionarCategoriaNoCarrinho"
      >
        <v-icon>mdi-cart</v-icon>
      </v-btn>
    </template>
  </div>
</template>

<script>
import InputFormatadorDeValor from "../../../../utils/InputFormatadorDeValor.vue";
import ValidaLoteMinimo from "../../../ValidaLoteMinimo";

import {card_selecionado} from "../Helpers/CardSelecionado";
import {adicionarCategoriaNoCarrinho} from "../../../../../api/compras/MateriaPrima.js"
import {data_table_departamentos_carregando_dados} from "../../../../utils/dataTable/sysDataTableDepartamentos/CarregandoDados.js";
import {logout} from "../../../../../helpers";

export default {
  name: "AdicionaNoCarrinho",
  mixins: [data_table_departamentos_carregando_dados, card_selecionado],
  components: {
    ValidaLoteMinimo,
    InputFormatadorDeValor
  },
  props: {
    linha: {
      type: Object,
      required: true
    }
  },
  computed: {
    LOTE_MINIMO_VALIDO() {
      if (!this.linha.lote_minimo) return false;

      const qtd_compra = Number(this.linha.sugestao_compra_peso).toFixed(4);
      const modulo = Number((qtd_compra % this.linha.lote_minimo).toFixed(4));

      return (modulo === 0 || modulo === Number(this.linha.lote_minimo));
    },
    CATEGORIA_REQUISICAO() {
      const {
        idcategoria,
        tipo_compra,
        sugestao_compra_peso: quantidade,
        sugestao_compra_peso_fixa: sugerido,
      } = this.linha;

      return {
        quantidade,
        sugerido,
        tipo_compra,
        idcategoria
      }
    },
    DISABILITAR_EDICAO_INPUT() {
      return this.data_table_departamentos_carregando_dados || this.card_selecionado.chave === 'itens_em_transito';
    },
    GRUPO_COMPRA() {
      return this.$store.getters['usuario/getGrupoCompras'];
    }
  },
  methods: {
    adicionarCategoriaNoCarrinho() {
      if ((!this.linha.comprar_fora_lote_minimo && !this.LOTE_MINIMO_VALIDO) || this.linha.sugestao_compra_peso <= 0) return;

      const requisicao = {
        grupo_compra: this.GRUPO_COMPRA,
        categorias: this.CATEGORIA_REQUISICAO
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        adicionarCategoriaNoCarrinho(requisicao).then(this.categoriaAdicionadaComSucesso).catch(logout)
      );
    },
    categoriaAdicionadaComSucesso() {
      this.$emit('produto-adicionado-carrinho', {})
    },
    incrementarSugestao() {
      this.linha.sugestao_compra_peso++;
    },
    decrementarSugestao() {
      this.linha.sugestao_compra_peso--;
    }
  }
}
</script>

<style scoped>

</style>
